import React, { useEffect, useReducer } from "react";

import Table from "./partials/Table";
import Summary from "./partials/Summary";
import { classicRegionName } from "../../../helper/classicRegion";

export const Context = React.createContext(null);

const initialFilterData = {
  channel: '',
  ticketType: 'single'
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        ...action.payload
      }
    case 'SET_TICKET_TYPE':
      return {
        ...state,
        ticketType: action.payload
      }
    default:
      return {
        ...state
      }
  }
}

export default ({ region }) => {

  var [state, dispatch] = useReducer(reducer, initialFilterData);

  useEffect(() => {
    document.title = `Vé ${classicRegionName(region)} đang bán`
  }, [region]);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <Summary region={region} />

      <Table region={region} />
    </Context.Provider>
  );
};
